<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "OptionChart",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "300px"
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    chart: null,
    newOption: {
      title: {
        show: true,
        textStyle: {
          color: "#bcbcbc"
        },
        text: "No Data",
        left: "center",
        top: "center"
      },
      series: []
    }
  }),
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      }
    }
  },
  mounted() {
    const vm = this;
    vm.resizeHandler = function() {
      if (vm.chart) {
        vm.chart.resize();
      }
    };
    vm.initChart();
    vm.$nextTick(() => {
      vm.resizeHandler();
    });
    window.addEventListener("resize", vm.resizeHandler);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    window.removeEventListener("resize", this.resizeHandler);
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setOptions(option = {}) {
      if (option.series.length === 0) {
        this.chart.setOption(this.newOption, true);
      } else {
        this.chart.setOption(option);
      }
    },
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions(this.chartData);
    }
  }
};
</script>
